import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import EducationCB from './EducationCB';
import EducationCollab from './EducationCollab';
import EducationConc from './EducationConc';
import EducationOv from './EducationOv';
import EducationSF from './EducationSF';
import EducationTA from './EducationTA';
import EducationVg from './EducationVg';
import './StyleE.css';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const EducationLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#EducationOv') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key === '#EducationSF') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key === '#EducationVg') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackV('transparent');
    } else if (key === '#EducationCB') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key === '#EducationTA') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorA']);
      setBackVI('transparent');
      setBackVII('transparent');
    } else if (key === '#EducationCollab') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI(appColors['ColorA']);
      setBackV('transparent');
      setBackVII('transparent');
    } else if (key === '#EducationConc') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVII(appColors['ColorA']);
      setBackVI('transparent');
      setBackV('transparent');
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#EducationOv' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Overview</Text></Content>}/>
          <Link href='#EducationSF' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Science Fair</Text></Content>}/>
          <Link href='#EducationVg' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Videogame</Text></Content>}/>
          <Link href='#EducationCB' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '2.5vh'}}>Children’s Book</Text></Content>}/>
          <Link href='#EducationTA' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorA'], fontSize: '2.3vh'}}>Transform Aging</Text></Content>}/>
          <Link href='#EducationCollab' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorA'], fontSize: '2.8vh'}}>Collaborations</Text></Content>}/>
          <Link href='#EducationConc' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Conclusions</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> E&nbsp;<br/> D&nbsp;<br/> U&nbsp;<br/> C&nbsp;<br/> A&nbsp;<br/> T&nbsp;<br/> I&nbsp;<br/> O&nbsp;<br/> N&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='EducationOv'>
              <EducationOv/>
            </div>
            <div id='EducationSF'>
              <EducationSF/>
            </div>
            <div id='EducationVg'>
              <EducationVg/>
            </div>
            <div id='EducationCB'>
              <EducationCB/>
            </div>
            <div id='EducationTA'>
              <EducationTA/>
            </div>
            <div id='EducationCollab'>
              <EducationCollab/>
            </div>
            <div id='EducationConc'>
              <EducationConc/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EducationLogic;
